import Form, {ButtonItem, ButtonOptions, Item, Label, SimpleItem} from "devextreme-react/form"
import notify from "devextreme/ui/notify"
import React, {useEffect, useRef, useState} from "react"
import {getCompanyInfo} from "../../api/resource"
import {Button} from "devextreme-react/button"
import HelpPopup from "../../components/help-popup/help-popup"
import {useReqPopup} from "../../contexts/req-popup"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHeadset, faPenClip} from "@fortawesome/free-solid-svg-icons";
import ExtFileUploader from "../../components/file-uploader/file-uploader";
import LoadIndicator from "devextreme-react/load-indicator";
import {sendHelpRequest} from "../../api/request";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";


const HelpPage = () => {

    const [company, setCompany] = useState({phone: 'Нет данных', adress: 'Нет данных'})
    const {setVisibleHelpPopup} = useReqPopup()
    useEffect(() => {
        (async function(){
            const companyData = await getCompanyInfo()
            if (companyData.isOk) {
                setCompany(companyData.data)

            } else {
                notify(companyData.message,'error',10000)
            }
        })()
    },[])
    const onHelpBtnClick = () => {
        setVisibleHelpPopup(true)
    }

    //region tatenergo popup
    const [loading, setLoading] = useState(false)
    const formData = useRef({})
    const extFileUploaderRef = useRef();
    const onSendRequest = async (e) => {
        e.preventDefault()
        const {message, attachments} = formData.current

        if (!message) {
            notify('Введите текст сообщения!', 'error', 5000)
            return
        }

        setLoading(true)
        const fd = new FormData()
        fd.append('message', message)
        if (process.env.REACT_APP_NAME_ENV === 'tatenergosbyt') fd.append('type',21)//type_request
        //прикрепляем к заявке вложения
        if (attachments)
            for (let i=0; i<attachments.length; i++) {
                fd.append('file',attachments[i])
            }

        const result = await sendHelpRequest(fd)
        if (result.isOk) { //если успешно создали заявку
            setVisibleHelpPopup(false)
            extFileUploaderRef.current.clearAttachFiles();
            formData.current.attachments = undefined;
            formData.current.message = '';
            notify(result.message, 'success', 5000)
        } else {
            notify(result.message, 'error', 5000);
        }

        setLoading(false)
    }
    const messageOptions = {
        autoResizeEnabled: true
    }
    //endregion

    return (
        <div className={'content-block dx-card responsive-paddings big-input'}>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faHeadset} />
            <h3><strong><ZagolovokFromMenu/></strong></h3>
            <Form labelMode={'floating'} colCount={1} readOnly={true}>
                <SimpleItem dataField="adressField" editorOptions={{value: company.adress}}><Label text={"Адрес компании"}></Label></SimpleItem>
                <SimpleItem dataField="phoneField" editorOptions={{value: company.phone}}><Label text={"Телефон компании"}></Label></SimpleItem>
            </Form>
            {process.env.REACT_APP_NAME_ENV !== 'tatenergosbyt' ?
                <>
                    <Button style={{marginTop: '20px'}} type={'default'} text="Написать в тех. поддержку" icon="edit" onClick={onHelpBtnClick}></Button>
                    <HelpPopup />
                </>
                :
                <>
                    <div className='mt-4'>
                        <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faPenClip}/>
                        <h3><strong><ZagolovokFromMenu/></strong></h3>
                    </div>
                    <form onSubmit={onSendRequest}>
                        <Form labelMode={'floating'} formData={formData.current}>
                            <Item dataField="message" editorType="dxTextArea" editorOptions={messageOptions}>
                                <Label text="Текст запроса"/>
                            </Item>
                            <Item>
                                <ExtFileUploader ref={extFileUploaderRef}
                                                 setfile={(e) => formData.current.attachments = e}></ExtFileUploader>
                            </Item>
                            <ButtonItem horizontalAlignment="left">
                                <ButtonOptions
                                    type={'default'}
                                    useSubmitBehavior={true}
                                    text="Отправить"
                                    icon="email"
                                    disabled={loading}
                                >
                                </ButtonOptions>
                            </ButtonItem>
                        </Form>
                    </form>
                    <LoadIndicator width={'24px'} height={'24px'} visible={loading}/>
                </>
            }
        </div>
    )
}

export default HelpPage
